// Find deepest child that has URL
export const getProductLink = (link, currentProgram) => {
  let subLink = link

  while (subLink.children) {
    let children

    // If first child has URL, take it. Otherwise it's just group.
    if (subLink.children[0]?.url) {
      children = subLink.children
    }

    // Try to find children that has current program link.
    if (subLink.children[0]?.children) {
      const programChildren = subLink.children.find(child =>
        child.children.find(link => link.key === currentProgram)
      )
      children = programChildren
        ? programChildren.children
        : subLink.children[0].children
    }

    subLink = children.find(link => link.key === currentProgram) ?? children[0]
  }

  return subLink
}

export const CURRENT_PRODUCT = "CURRENT_PRODUCT"

export const saveCurrentProductToSessionStorage = (pageName: string) => {
  sessionStorage.setItem(CURRENT_PRODUCT, pageName)
}

export const getCurrentProductFromSessionStorage = () => {
  return sessionStorage.getItem(CURRENT_PRODUCT)
}
